
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const UploadFTLPod = (props) => {
    // console.log(props,"Subbbbbb");
    const handleClick = (e) => {
        e.stopPropagation();

        // if (iconColor === "gray") {
        //     return; // Do nothing if the color is gray
        // }

         props.onClickUploadPOD(props);
    };

    // const iconColor = props.isSubmittedPOD === 1 ? "gray" : "#3a3fa6";
    return (                            
        <button
            onClick={handleClick}
            style={{border:"none", backgroundColor:"transparent",
                pointerEvents: ((props.data.hasOwnProperty('status') && props.data.status !==4)) ? "none" : "auto", 
                opacity: ((props.data.hasOwnProperty('status') && props.data.status!==4)) ? 0.5 : 1, }}
            // className="btn btn-info"
            // style={{
            //     padding: "8px 10px",
            //     fontSize: "13px",
            //     margin: "0",
            //     display: "flex",           
            //     alignItems: "center",     
            //     justifyContent: "center",  
            //     height: "100%",            
            //     boxSizing: "border-box"    
            // }}
            title="Upload POD"
            disabled={props.data.hasOwnProperty('uploaded_pod_document')}
        >
            <i
                className="icofont icofont-upload f15"
                style={{
                    fontSize: "15px",
                    color: (props.data.hasOwnProperty('uploaded_pod_document') || props.data.status !==4) ? "grey" :"green",
                    lineHeight: "1",       
                }}
            ></i>
        </button>
        );
};

export default UploadFTLPod;
